import { Phone, Flame } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV_LINKS = [
  { label: "Services", href: "/#services" },
  { label: "FAQ", href: "/#faq" },
  { label: "Service Area", href: "/#service-area" },
];

export function Header() {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="/#top" data-testid="header-logo-link" className="flex items-center gap-2">
          <span className="w-9 h-9 rounded-md bg-primary flex items-center justify-center">
            <Flame className="w-5 h-5 text-white" strokeWidth={2} />
          </span>
          <span className="font-heading font-bold text-lg tracking-tight text-foreground">
            Exotictileandmasonry
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-8" data-testid="header-nav">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className="text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>
        <Button
          asChild
          data-testid="header-call-button"
          className="btn-press bg-primary hover:bg-[#A93A24] text-white rounded-md font-semibold"
        >
          <a href="tel:+19712553874" className="flex items-center gap-2">
            <Phone className="w-4 h-4" strokeWidth={2} />
            <span className="hidden sm:inline">971-255-3874</span>
            <span className="sm:hidden">Call</span>
          </a>
        </Button>
      </div>
    </header>
  );
}
